import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartSimple,
  faGem,
  faLayerGroup,
  faListCheck,
  faMagnifyingGlass,
  faRightFromBracket,
  faTriangleExclamation,
  faUsers
} from "@fortawesome/free-solid-svg-icons";

import { logout } from "../../redux/actions/authActions";

export default function Sidebar() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  function closeMobile() {
    setOpen(false);
  }

  return (
    <>
      <aside className={`navbar navbar-vertical navbar-expand-lg ${open ? "show" : ""}`}>
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={() => setOpen((v) => !v)}
          >
            <span className="navbar-toggler-icon" />
          </button>

          <h1 className="navbar-brand navbar-brand-autodark mb-0">
            <NavLink
              className="d-flex align-items-center gap-2 text-decoration-none"
              to="/dashboard"
              onClick={closeMobile}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.png`}
                alt=""
                width={32}
                height={32}
                className="flex-shrink-0"
                style={{ objectFit: "contain" }}
              />
              <span>Rock Dashboard</span>
            </NavLink>
          </h1>

          <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>
            <ul className="navbar-nav pt-lg-3">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/dashboard"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faChartSimple} />
                  </span>
                  <span className="nav-link-title">Dashboard</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/error-logs"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                  </span>
                  <span className="nav-link-title">Error Logs</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/categories"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faLayerGroup} />
                  </span>
                  <span className="nav-link-title">Categories</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/gems"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faGem} />
                  </span>
                  <span className="nav-link-title">Gems</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/tasks"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faListCheck} />
                  </span>
                  <span className="nav-link-title">Task Manager</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/real-or-fake"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </span>
                  <span className="nav-link-title">Real or Fake</span>
                </NavLink>
              </li>

              <li className="nav-item">
                <div className="nav-item-header text-muted small text-uppercase px-3 pt-3 pb-1"
                  style={{ letterSpacing: "0.05em", fontSize: "0.7rem" }}>
                  Admin
                </div>
              </li>

              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link songsnap-nav-link ${isActive ? "active" : ""}`
                  }
                  to="/admin/users"
                  onClick={closeMobile}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faUsers} />
                  </span>
                  <span className="nav-link-title">Users</span>
                </NavLink>
              </li>

              <li className="nav-item mt-auto">
                <button
                  className="nav-link songsnap-nav-link btn btn-link w-100 text-start"
                  type="button"
                  onClick={() => dispatch(logout())}
                >
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <FontAwesomeIcon icon={faRightFromBracket} />
                  </span>
                  <span className="nav-link-title">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </aside>
      {open ? <div className="sidebar-backdrop" onClick={() => setOpen(false)} /> : null}
    </>
  );
}

